import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { GoogleMap, MarkerF, InfoWindowF } from "@react-google-maps/api";
import { MAP_STYLE, useGoogleReady, GMAPS_KEY } from "../lib/gmaps";

const goldPin = () => ({
  path: "M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24c0-6.6-5.4-12-12-12z",
  fillColor: "#b8935f", fillOpacity: 1, strokeColor: "#ffffff", strokeWeight: 2,
  scale: 1.1, anchor: new window.google.maps.Point(12, 36),
});

const Placeholder = ({ h }) => <div className="rounded-2xl border border-[#f0ece5] bg-[#faf7f2]" style={{ height: h }} />;

export const PropertyMap = ({ lat, lng, title }) => {
  const isLoaded = useGoogleReady();
  if (!lat || !lng) return <Placeholder h={340} />;
  if (!isLoaded) return <Placeholder h={340} />;
  return (
    <div className="rounded-2xl overflow-hidden border border-[#f0ece5] h-[340px]" data-testid="property-google-map">
      <GoogleMap mapContainerStyle={{ width: "100%", height: "100%" }} center={{ lat, lng }} zoom={15}
        options={{ styles: MAP_STYLE, disableDefaultUI: true, zoomControl: true, gestureHandling: "cooperative" }}>
        <MarkerF position={{ lat, lng }} icon={goldPin()} title={title} />
      </GoogleMap>
    </div>
  );
};

export const ListingsMap = ({ properties }) => {
  const isLoaded = useGoogleReady();
  const [active, setActive] = useState(null);
  const pts = (properties || []).filter((p) => p.lat && p.lng);
  const onLoad = useCallback((map) => {
    if (pts.length > 1) {
      const b = new window.google.maps.LatLngBounds();
      pts.forEach((p) => b.extend({ lat: p.lat, lng: p.lng }));
      map.fitBounds(b, 60);
    }
  }, [pts]);
  if (pts.length === 0) return null;
  if (!isLoaded) return <Placeholder h={560} />;
  return (
    <div className="rounded-2xl overflow-hidden border border-[#f0ece5] h-[560px] sticky top-[150px]" data-testid="listings-google-map">
      <GoogleMap mapContainerStyle={{ width: "100%", height: "100%" }} center={{ lat: pts[0].lat, lng: pts[0].lng }} zoom={12}
        onLoad={onLoad} options={{ styles: MAP_STYLE, disableDefaultUI: true, zoomControl: true }}>
        {pts.map((p) => (
          <MarkerF key={p.id} position={{ lat: p.lat, lng: p.lng }} icon={goldPin()} onClick={() => setActive(p)} />
        ))}
        {active && (
          <InfoWindowF position={{ lat: active.lat, lng: active.lng }} onCloseClick={() => setActive(null)}>
            <Link to={`/property/${active.slug}`} className="block w-[180px]">
              <img src={active.images[0]} alt={active.title} style={{ width: "180px", height: "110px", objectFit: "cover", borderRadius: "6px" }} />
              <strong style={{ display: "block", marginTop: "6px", color: "#2b2b2b" }}>{active.title}</strong>
              <span style={{ color: "#b8935f", fontWeight: 600 }}>£{active.price.toLocaleString()}{active.status === "to-rent" ? " pcm" : ""}</span>
            </Link>
          </InfoWindowF>
        )}
      </GoogleMap>
    </div>
  );
};
